export const TAB_BASIC = 'BASIC';
export const TAB_BUDGET = 'BUDGET';
export const TAB_FAVORITE = 'FAVORITE';
